import {motion, useInView} from 'framer-motion'
import {useRef} from 'react'

import {AnimatedChar} from './AnimatedChar'
import {PlaceholderChar} from './PlaceholderChar'

export interface AnimatedCountProps {
  value: number
  direction: 'COUNT_UP' | 'COUNT_DOWN'
  /** transform the number output */
  transformFn?: (v: number) => string
}

export const AnimatedCount = ({value, direction, transformFn}: AnimatedCountProps) => {
  const ref = useRef<HTMLParagraphElement>(null)
  const isInView = useInView(ref, {once: true})

  const transformedValue = transformFn ? transformFn(value) : `${value}`
  const chars = transformedValue.split('')

  return (
    <div className={'relative overflow-hidden'}>
      <motion.span
        ref={ref}
        className={'absolute flex'}
      >
        {chars.map((char, index) => (
          <AnimatedChar
            key={index}
            isInView={isInView}
            char={char}
            index={index}
            direction={direction}
          />
        ))
        }
      </motion.span>
      <span className={'invisible flex'}>
        {chars.map((char, index) => (
          <PlaceholderChar
            key={index}
            char={char}
          />
        ))}
      </span>
    </div>
  )
}
